import { createApp } from 'vue'
import QRCode from 'qrcode'
// import VueQrcode from '@chenfengyuan/vue-qrcode';
import 'animate.css';

import 'lib-flexible';
import '@/assets/font/font.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElIcons from '@element-plus/icons-vue';
import router from "@/routers";

import http from './http/axios'



import App from './App.vue'

const app = createApp(App)

app.config.globalProperties.$api = http;

Object.keys(ElIcons).forEach((key) => {
  app.component(key, ElIcons[key]);
});


const generateQR = async text => {
  console.log(5555555555555);
  try {
    const opts = {
      errorCorrectionLevel: 'H',
      type: 'image/png',
      quality: 0.9,
      margin: 1,
    };
    const png = await QRCode.toDataURL(text, opts);
    console.log(png);
    return png;
  } catch (err) {
    console.error(err);
  }
};

app.config.globalProperties.$generateQR = generateQR;

app.use(router)
app.use(ElementPlus)
app.mount('#app')


